import { getIssuePriority } from 'shared/constants/issues';
import {
  IssueTitleColumn,
  EmergencyColumn,
  OrderTimeColumn,
  CompleteTimeColumn,
  PriceColumn,
  ViewColumn,
  FlagColumn,
} from '../commonColumns';
import logger from 'utils/logger';

const log = logger.createLogger('kenshinTableReceivedBilling');

export const getKenshinTableData = (
  billData,
  selectedSrcOrgId,
  selectedBillingMonth
) => {
  const bills = billData.find(
    (bill) =>
      bill.orgId === selectedSrcOrgId &&
      bill.billedMonthYear === selectedBillingMonth
  );
  if (!bills) return [];
  const billsData = bills.bills;

  billsData.sort((a, b) => a.createdAt - b.createdAt);

  const tableData = billsData.map((bill) => {
    const {
      id,
      issueCreatedAt,
      createdAt,
      issueId,
      issueTitle,
      issuePriority,
      originalFee,
      currentFee,
      starred,
    } = bill;

    return {
      issueTitle: issueTitle,
      emergency: getIssuePriority(issuePriority),
      orderTime: issueCreatedAt,
      completeTime: createdAt,
      price: {
        originalFee: originalFee,
        currentFee: currentFee,
      },
      view: {
        billId: id,
        issueId: issueId,
      },
      flag: starred,
    };
  });

  return tableData;
};

export const kenshinTableColumns = (openKenshinIssue) => {
  return [
    IssueTitleColumn(),
    EmergencyColumn(),
    OrderTimeColumn(),
    CompleteTimeColumn(),
    PriceColumn(),
    ViewColumn(openKenshinIssue),
    FlagColumn(),
  ];
};
